import React, { useState } from "react";
import { Link } from "react-router-dom";
// import IconSocalFurs from './SocalDate.jpg'
import IconSocalFurs from './Socalfurs.jpg'
import './AboutPage.css'
// commit
export default function AttendingPage() {

  return (

       <div className = "about-us-main-container">
                  {/* <img className="homepage-main-icon" src={AfcImage} alt="Socalfurs.com" /> */}

            <div className = "about-us-container-1">
                      <header className = "about-us-header">Attending a Furry Meetup - Tips and Info</header>
                      <p className = "about-us-p">
                            Hi there! Interested in coming to one of the local furry meetups? 
                            That’s awesome! Here are a few things to know before you attend.
                            Learn about our groups here: <Link to="/groups">Our Local Furry Groups & Meets</Link>

                        </p>
                     <h2>How Meetups Work</h2>
                          <p className = "about-us-p">
                            All meetups listed on our site are organized by individual community 
                            members. Not Socalfurs itself. We don’t directly run or host these events; 
                            instead, we help share them so others can find and attend. That means
                             each event might have its own rules, format, or organizers, so be sure to 
                             read the details for the specific meetup you're interested in. Our local
                             furry meetups are usually posted to our calendar channel or google calendar!
                             <ul>

                              <li><Link to ="/calendar">Southern California Furry Calendar Page</Link></li>
                               <li><a href = "https://t.me/+LPKHccQiNR03ZDQ7">SocalFurs Telegram</a></li>
                               <li><a href = "https://t.me/SoCalFursCalendar">Socal Furs Telegram Calendar Channel</a></li>
                       
                          <ul>
                           
                          </ul>
                        
                      
                             </ul>
                        </p>                  <div>
                          <p className = "about-us-p">
                            <strong>Dislcaimer:</strong> Event times and listings on this calendar are subject to change. 
                            Some events may be moved or canceled, and these updates may not always be reflected on the 
                            calendar in real time. For the most accurate and up-to-date information, please consider joining 
                            the <a href = "https://t.me/+LPKHccQiNR03ZDQ7">Telegram group.</a></p>
                      </div>
                     
                                  <h2>Respect and Etiquette</h2>
                          <p className = "about-us-p">
                            When attending a meetup, always be respectful of others. Especially those in 
                            fursuit or costume.
                            <ul>
                                <li>Don’t take photos without permission. Most folks are happy to pose for a picture, 
                                    but it’s polite to ask first.</li>

                                <li>Always ask before touching or hugging someone.</li>

                                <li>Be mindful of personal space and boundaries, even if someone’s in costume.
                                    They’re still a person underneath.</li>

                            </ul>
                        </p>
                        <h2>Using Telegram (Recommended)</h2>
                          <p className = "about-us-p">
                           While not required, <Link to = "https://telegram.org/">Telegram </Link>is highly recommended. It’s a free messaging app 
                           and is how most furry events are coordinated. Many meetups will have
                            their own Telegram group for updates, chatting, and asking questions. 
                            If you want to stay informed or contact the organizer, Telegram is usually
                            the best way to do it.
                        </p>
                       <h2>General Safety Tips</h2>
                          <p className = "about-us-p">
                            <ul>
                                <li>If you're new, consider bringing a friend or letting someone 
                           know where you’re going.</li>

                                <li>Be aware of your surroundings and follow 
                                    any posted event rules or venue guidelines.</li>

                                <li>If anything makes you uncomfortable, feel free to leave or 
                                    talk to the event host. Most are very welcoming and want
                                     everyone to have a good time.</li>

                            </ul>
                        </p>
                      

                     

                      

            </div>

            <div className = "about-us-space"></div>
            <div className = "about-us-image-container">
              <img className = "about-us-img" src = {IconSocalFurs}></img>
            </div>
    
                      
        </div>

         
  );
}
